module.exports = __webpack_public_path__ + "img/旺旺大礼包2.8cefe42b.jpg";